import React, { useEffect, useState, useContext, useMemo, useRef } from "react";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";

import { useNavigate } from "react-router-dom";
import FareRule from "./FareRule";
import { AuthContext } from "../../Routes/AuthProvider"

const ResultHtml = ({ data, adult, child, infant, requestBody, flights, loading, error, handleBookNow, fareType }) => {

  const [loadingFlightIndex, setLoadingFlightIndex] = useState(null);
  const [selectedFlight, setSelectedFlight] = useState(null);
  const [selectedFareIndex, setSelectedFareIndex] = useState(null);
  const [fareRuleIndex, setFareRuleIndex] = useState(null);
  const { name, userName, roles, corporateId } = useContext(AuthContext);
  // const [sortType, setSortType] = useState("CHEAPEST");
  const [sortType, setSortType] = useState("DEPARTURE");
  const [loadFareRule, setLoadFareRule] = useState(false);
  const [loadFareRuleTab, setLoadFareRuleTab] = useState(false);
  // SORTING (CHEAPEST ON TOP BY DEFAULT)

  const [selectedFareMap, setSelectedFareMap] = useState({});

  const sortedFlights = useMemo(() => {
    if (!flights || flights.length === 0) return [];

    const copied = [...flights];
    ////console.log("copied FASTEST", copied);
    const getMinFare = (flight) => {
      if (flight.fares && flight.fares.length > 0) {
        return Math.min(...flight.fares.map(f => f.totalFare || 0));
      }
      return flight.fareDetails?.totalFare || 0;
    };

    const getDurationInMinutes = (duration) => {
      if (!duration) return 99999;
      const [h, m] = duration.split(":").map(Number);
      return h * 60 + m;
    };

    switch (sortType) {
      case "CHEAPEST":
        return copied.sort(
          (a, b) => getMinFare(a) - getMinFare(b)
        );

      case "FASTEST":
        return copied.sort(
          (a, b) =>
            getDurationInMinutes(a.totalDuration) -
            getDurationInMinutes(b.totalDuration)
        );

      case "NONSTOP":
        return copied.sort(
          (a, b) =>
            (a.segments?.length === 1 ? 0 : 1) -
            (b.segments?.length === 1 ? 0 : 1)
        );

      case "DEPARTURE":
        return copied.sort(
          (a, b) =>
            new Date(a.segments?.[0]?.departDateTime) -
            new Date(b.segments?.[0]?.departDateTime)
        );

      default:
        return copied;
    }
  }, [flights, sortType]);


  const ExportToExcel = () => {
    const excelData = flights.map((flight) => {
      const seg = flight.segments?.[0];
      const fare = flight.fares?.[0];

      return {
        // ItemNo: flight.itemNo,
        // Supplier: flight.supplierCode,
        // Source: flight.supSource,
        Airline: seg?.airLineName,
        AirlineCode: seg?.airLineCode,
        FlightNumber: seg?.flightNumber,
        From: seg?.departAirportCode,
        FromCity: seg?.departCityName,
        FromAirport: seg?.departAirportName,
        DepartTerminal: seg?.departTerminal,
        DepartureTime: seg?.departDateTime?.split("T")[1],
        To: seg?.arrivalAirportCode,
        ToCity: seg?.arrivalCityName,
        ToAirport: seg?.arrivalAirportName,
        ArrivalTerminal: seg?.arrivalTerminal,
        ArrivalTime: seg?.arrivalDateTime?.split("T")[1],
        Duration: seg?.duration,
        TotalDuration: flight.totalDuration,
        Stops: flight.stops,
        AvailableSeats: seg?.availableSeats,
        Equipment: seg?.equipmentType,
        BaseFare: fare?.totalBaseFare,
        OtherTax: fare?.totalOtherTax,
        TotalFare: fare?.totalFare,
        NetAmount: fare?.netAmount,
        Refundable: fare?.isRefundable ? "Yes" : "No",
        FareType: fare?.fareType
      };
    });

    const worksheet = XLSX.utils.json_to_sheet(excelData);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Flights");
    const excelBuffer = XLSX.write(workbook, {
      bookType: "xlsx",
      type: "array"
    });

    const data = new Blob([excelBuffer], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
    });

    saveAs(data, "FlightList.xlsx");
  };

  // -------------------------
  // Helper Functions
  // -------------------------
  const formatTime = (dateString) => {
    if (!dateString) return "—";
    const date = new Date(dateString);
    return date.toLocaleTimeString([], { hour: "2-digit", minute: "2-digit" });
  };
  const navigate = useNavigate();
  const calcDuration = (start, end) => {
    if (!start || !end) return "—";
    const s = new Date(start);
    const e = new Date(end);
    const diff = Math.abs(e - s) / 1000 / 60;
    const h = Math.floor(diff / 60);
    const m = diff % 60;
    return `${h}h ${m}m`;
  };

  // -------------------------
  // Button Handlers

  const [selectedFare, setSelectedFare] = useState(null);


  const handleViewMoreFare = (flight) => {
    if (!flight) return;

    //console.log("View More Fare", flight);
    setSelectedFlight(flight);
    setSelectedFare(null);

    setTimeout(() => {
      const offcanvas = document.getElementById("ViewMoreFare");
      if (offcanvas) {
        const bsOffcanvas = new window.bootstrap.Offcanvas(offcanvas);
        bsOffcanvas.show();
      }
    }, 50); // wait for React to update state
  };
  const formatDateForDisplay = (dateStr) => {
    if (!dateStr) return "—";
    const date = new Date(dateStr);
    const dd = String(date.getDate()).padStart(2, "0");
    const mm = String(date.getMonth() + 1).padStart(2, "0");
    const yyyy = date.getFullYear();
    return `${dd}/${mm}/${yyyy}`;
  };

  const [activeTab, setActiveTab] = useState("info");
  const [showAdSelct, setshowAdSelct] = useState(false);
  const [selectedShareFlights, setSelectedShareFlights] = useState([]);
  const [removedShareFares, setRemovedShareFares] = useState([]);


  const generateShareHTML = () => {
    const escapeHTML = (value) =>
      String(value ?? "")
        .replace(/&/g, "&amp;")
        .replace(/</g, "&lt;")
        .replace(/>/g, "&gt;")
        .replace(/"/g, "&quot;")
        .replace(/'/g, "&#39;");

    let html = `
    <div style="font-family:Arial,Helvetica,sans-serif;color:#333;background:#fff;">
      <h2 style="margin:0 0 20px;color:#110942;font-size:22px;">
        Selected Flight Details
      </h2>
      <p>Dear Sir/Ma'am,</p>
      <p>Please find the selected international round-trip flight options below.</p>
  `;

    selectedShareFlights.forEach((selectedIndex, optionIndex) => {
      const flight = sortedFlights[selectedIndex];

      if (!flight) return;

      const segments = flight.segments || [];
      const firstSegment = segments[0] || {};
      const lastSegment = segments[segments.length - 1] || {};

      const stopCount = Math.max(segments.length - 1, 0);

      const viaCities = segments
        .slice(0, -1)
        .map(
          (segment) =>
            segment.arrivalCityName ||
            segment.arrivalCity ||
            segment.arrivalAirportName ||
            segment.destination ||
            ""
        )
        .filter(Boolean);

      const routeFrom =
        firstSegment.departAirportCode ||
        firstSegment.departCityName ||
        "";

      const routeTo =
        lastSegment.arrivalAirportCode ||
        lastSegment.arrivalCityName ||
        flight.arrivalCityName ||
        "";

      const route =
        routeFrom && routeTo
          ? `${routeFrom} - ${routeTo}`
          : routeFrom || routeTo || "N/A";

      const duration = flight.totalDuration
        ? (() => {
          const [hours, minutes] = String(
            flight.totalDuration
          ).split(":");

          const h = parseInt(hours || 0, 10);
          const m = parseInt(minutes || 0, 10);

          return (
            `${h > 0 ? `${h}h ` : ""}` +
            `${m > 0 ? `${m}m` : ""}`
          ).trim() || "N/A";
        })()
        : firstSegment.duration || "N/A";

      const fares = (flight.fares || [])
        .map((fare, fareIndex) => ({ fare, fareIndex }))
        .filter(
          ({ fareIndex }) =>
            !removedShareFares.some(
              (item) =>
                item.flightIndex === selectedIndex &&
                item.fareIndex === fareIndex
            )
        );

      let fareRows = "";

      fares.forEach(({ fare, fareIndex }) => {
        const fareType =
          fare.journeyFareInfos?.[0]?.type ||
          fare.fareName ||
          fare.fareType ||
          `Fare ${fareIndex + 1}`;

        const priceType =
          fare.journeyFareInfos?.[0]?.isRefundable ??
          fare.isRefundable;

        const priceText =
          priceType === true
            ? "Refundable"
            : priceType === false
              ? "Non Refundable"
              : "-";

        const priceColor =
          priceType === true
            ? "green"
            : priceType === false
              ? "red"
              : "#333";

        fareRows += `
        <tr>
          <td style="border:1px solid #ddd;padding:8px;text-align:center;">
            ${escapeHTML(fareType)}
          </td>
          <td style="border:1px solid #ddd;padding:8px;text-align:center;white-space:nowrap;">
            &#8377; ${Number(fare.totalFare || 0).toLocaleString("en-IN")}
          </td>
          <td style="border:1px solid #ddd;padding:8px;text-align:center;color:${priceColor};">
            ${priceText}
          </td>
        </tr>
      `;
      });

      html += `
      <div style="margin:25px 0 10px;">
        <h3 style="color:#110942;font-size:18px;margin:0 0 12px;">
          Option ${optionIndex + 1}
        </h3>

        <table style="width:100%;border-collapse:collapse;font-family:Arial,Helvetica,sans-serif;">
          <thead>
            <tr>
              ${[
          "Flight",
          "Departure",
          "Arrived",
          "Duration",
          "Stops",
          "Route",
          "Fare",
        ]
          .map(
            (heading) => `
                    <th style="border:1px solid #ddd;padding:10px;background:#110942;color:#fff;text-align:center;">
                      ${heading}
                    </th>
                  `
          )
          .join("")}
            </tr>
          </thead>

          <tbody>
            <tr>
              <td style="border:1px solid #ddd;padding:10px;text-align:center;">
                <strong>
                  ${escapeHTML(firstSegment.airLineName || "Unknown Airline")}
                  ${escapeHTML(firstSegment.airLineCode || "")} -
                  ${escapeHTML(firstSegment.flightNumber || "")}
                </strong>
              </td>

              <td style="border:1px solid #ddd;padding:10px;text-align:center;">
                <strong>
                  ${escapeHTML(firstSegment.departDateTime ? formatTime(firstSegment.departDateTime) : "N/A")}
                </strong>
                <br/>
                ${escapeHTML(firstSegment.departCityName || "")}
                ${escapeHTML(firstSegment.departAirportCode ? ` (${firstSegment.departAirportCode})` : "")}
              </td>

              <td style="border:1px solid #ddd;padding:10px;text-align:center;">
                <strong>
                  ${escapeHTML(lastSegment.arrivalDateTime ? formatTime(lastSegment.arrivalDateTime) : "N/A")}
                </strong>
                <br/>
                ${escapeHTML(lastSegment.arrivalCityName || flight.arrivalCityName || "")}
                ${escapeHTML(lastSegment.arrivalAirportCode ? ` (${lastSegment.arrivalAirportCode})` : "")}
              </td>

              <td style="border:1px solid #ddd;padding:10px;text-align:center;white-space:nowrap;">
                ${escapeHTML(duration)}
              </td>

              <td style="border:1px solid #ddd;padding:10px;text-align:center;">
                <strong>
                  ${stopCount === 0 ? "Non-stop" : `${stopCount} ${stopCount === 1 ? "Stop" : "Stops"}`}
                </strong>
                ${viaCities.length
          ? `<br/>via ${escapeHTML(viaCities.join(", "))}`
          : ""
        }
              </td>

              <td style="border:1px solid #ddd;padding:10px;text-align:center;">
                ${escapeHTML(route)}
              </td>

              <td style="border:1px solid #ddd;padding:5px;text-align:center;">
                ${fareRows
          ? `
                      <table style="width:100%;border-collapse:collapse;">
                        <thead>
                          <tr>
                            <th style="border:1px solid #ddd;padding:7px;background:#f1f1f1;">Fare Type</th>
                            <th style="border:1px solid #ddd;padding:7px;background:#f1f1f1;">Amount</th>
                            <th style="border:1px solid #ddd;padding:7px;background:#f1f1f1;">Price Type</th>
                          </tr>
                        </thead>
                        <tbody>${fareRows}</tbody>
                      </table>
                    `
          : '<span style="color:#777;">Fare not available</span>'
        }
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    `;
    });

    html += `</div>`;

    return html;
  };


  const generateSharePlainText = () => {
    let text =
      "Selected Flight Details\n\n" +
      "Dear Sir/Ma'am,\n\n" +
      "Please find the selected international round-trip flight options below.\n\n";

    selectedShareFlights.forEach((selectedIndex, optionIndex) => {
      const flight = sortedFlights[selectedIndex];

      if (!flight) return;

      const segments = flight.segments || [];
      const firstSegment = segments[0] || {};
      const lastSegment = segments[segments.length - 1] || {};

      const stopCount = Math.max(segments.length - 1, 0);

      const routeFrom =
        firstSegment.departAirportCode ||
        firstSegment.departCityName ||
        "";

      const routeTo =
        lastSegment.arrivalAirportCode ||
        lastSegment.arrivalCityName ||
        flight.arrivalCityName ||
        "";

      const route =
        routeFrom && routeTo
          ? `${routeFrom} - ${routeTo}`
          : routeFrom || routeTo || "N/A";

      const duration = flight.totalDuration
        ? (() => {
          const [hours, minutes] = String(
            flight.totalDuration
          ).split(":");

          const h = parseInt(hours || 0, 10);
          const m = parseInt(minutes || 0, 10);

          return (
            `${h > 0 ? `${h}h ` : ""}` +
            `${m > 0 ? `${m}m` : ""}`
          ).trim() || "N/A";
        })()
        : firstSegment.duration || "N/A";

      text +=
        `========================================\n` +
        `OPTION ${optionIndex + 1}\n` +
        `========================================\n` +
        `Route: ${route}\n` +
        `Flight: ${firstSegment.airLineName || "Unknown Airline"} ` +
        `${firstSegment.airLineCode || ""} ${firstSegment.flightNumber || ""}\n` +
        `Departure: ${firstSegment.departDateTime ? formatTime(firstSegment.departDateTime) : "N/A"} ` +
        `${firstSegment.departCityName || ""} (${firstSegment.departAirportCode || "—"})\n` +
        `Arrival: ${lastSegment.arrivalDateTime ? formatTime(lastSegment.arrivalDateTime) : "N/A"} ` +
        `${lastSegment.arrivalCityName || flight.arrivalCityName || ""} ` +
        `(${lastSegment.arrivalAirportCode || "—"})\n` +
        `Duration: ${duration}\n` +
        `Stops: ${stopCount === 0
          ? "Non-stop"
          : `${stopCount} ${stopCount === 1 ? "Stop" : "Stops"}`
        }\n`;

      if (stopCount > 0) {
        const viaCities = segments
          .slice(0, -1)
          .map(
            (segment) =>
              segment.arrivalCityName ||
              segment.arrivalCity ||
              segment.arrivalAirportName ||
              ""
          )
          .filter(Boolean);

        if (viaCities.length) {
          text += `Via: ${viaCities.join(", ")}\n`;
        }
      }

      text += "\nFARES:\n";

      const fares = (flight.fares || []).filter(
        (_, fareIndex) =>
          !removedShareFares.some(
            (item) =>
              item.flightIndex === selectedIndex &&
              item.fareIndex === fareIndex
          )
      );

      if (!fares.length) {
        text += "Fare not available\n";
      } else {
        fares.forEach((fare, fareIndex) => {
          const fareType =
            fare.journeyFareInfos?.[0]?.type ||
            fare.fareName ||
            fare.fareType ||
            `Fare ${fareIndex + 1}`;

          const refundable =
            fare.journeyFareInfos?.[0]?.isRefundable ??
            fare.isRefundable;

          const refundStatus =
            refundable === true
              ? "Refundable"
              : refundable === false
                ? "Non Refundable"
                : "-";

          text +=
            `${fareType} | INR ${Number(fare.totalFare || 0).toLocaleString("en-IN")} | ${refundStatus}\n`;
        });
      }

      text += "\n";
    });

    return text;
  };

  const handleCopyHTML = async () => {
    if (!selectedShareFlights.length) {
      window.alert("Please select at least one flight.");
      return;
    }

    const html = generateShareHTML();
    const plainText = generateSharePlainText();

    try {
      if (
        navigator.clipboard?.write &&
        typeof ClipboardItem !== "undefined"
      ) {
        const clipboardItem = new ClipboardItem({
          "text/html": new Blob([html], {
            type: "text/html",
          }),
          "text/plain": new Blob([plainText], {
            type: "text/plain",
          }),
        });

        await navigator.clipboard.write([clipboardItem]);

        window.alert(
          "All selected flight options copied successfully. Paste into your email or supported chat application."
        );

        return;
      }

      // Fallback for browsers without rich clipboard support
      const tempDiv = document.createElement("div");

      tempDiv.contentEditable = "true";
      tempDiv.innerHTML = html;

      Object.assign(tempDiv.style, {
        position: "fixed",
        left: "-10000px",
        top: "0",
        width: "1000px",
        background: "#fff",
      });

      document.body.appendChild(tempDiv);

      const range = document.createRange();
      range.selectNodeContents(tempDiv);

      const selection = window.getSelection();
      selection?.removeAllRanges();
      selection?.addRange(range);

      const copied = document.execCommand("copy");

      selection?.removeAllRanges();
      document.body.removeChild(tempDiv);

      if (!copied) {
        throw new Error("Rich HTML clipboard copy failed.");
      }

      window.alert(
        "Selected flight options copied. Paste into your email or chat application."
      );
    } catch (error) {
      console.error("Copy Flight HTML Error:", error);

      // Plain-text fallback, if clipboard writing is permitted
      try {
        await navigator.clipboard.writeText(plainText);

        window.alert(
          "Flight details copied as plain text. All selected options are included."
        );
      } catch (fallbackError) {
        console.error("Plain-text clipboard copy error:", fallbackError);

        window.alert(
          "Unable to copy flight details. Please use HTTPS or localhost and allow clipboard access."
        );
      }
    }
  };





  const handleWhatsAppSelectedFlights = () => {
    const selectedFlights = getSelectedShareData();

    if (!selectedFlights.length) {
      window.alert("Please select at least one flight option.");
      return;
    }

    const message = selectedFlights
      .map((option) => {
        const {
          optionIndex,
          allSegments = [],
          route = [],
          fares = [],
        } = option;

        const flightDetails = allSegments
          .map((segment, segmentIndex) => {
            const airline =
              segment.airLineName ||
              segment.airLineCode ||
              "Unknown Airline";

            const flightNumber = segment.flightNumber || "";

            return (
              `Flight ${segmentIndex + 1}: ${airline} ${flightNumber}\n` +
              `Departure: ${getShareDateTime(segment.departDateTime)} ` +
              `(${segment.departAirportCode || segment.departCityName || "—"})\n` +
              `Arrival: ${getShareDateTime(segment.arrivalDateTime)} ` +
              `(${segment.arrivalAirportCode || segment.arrivalCityName || "—"})\n` +
              `Duration: ${segment.duration || "—"}`
            );
          })
          .join("\n\n");

        const fareDetails = fares.length
          ? fares
            .map((fare) => {
              return (
                `${getShareFareName(fare, fare.fareIndex)}: ` +
                `INR ${getShareAmountText(fare)}\n` +
                `Refund Status: ${getShareRefundStatus(fare)}`
              );
            })
            .join("\n\n")
          : "No fares available";

        return (
          `Option ${optionIndex}\n` +
          `Route: ${route.join(" → ") || "—"}\n\n` +
          `${flightDetails || "Flight details not available"}\n\n` +
          `Fares:\n${fareDetails}`
        );
      })
      .join("\n\n--------------------\n\n");

    const whatsappUrl =
      `https://wa.me/?text=${encodeURIComponent(message)}`;

    window.open(
      whatsappUrl,
      "_blank",
      "noopener,noreferrer"
    );
  };




  const getSelectedShareData = () => {
    return selectedShareFlights
      .map((selectedIndex, optionIndex) => {
        const flight = sortedFlights[selectedIndex];

        if (!flight) {
          return null;
        }

        const allSegments = flight.segments || [];

        // Exclude fares removed by the user
        const fares = (flight.fares || [])
          .map((fare, fareIndex) => ({
            ...fare,
            fareIndex,
          }))
          .filter(
            (fare) =>
              !removedShareFares.some(
                (item) =>
                  item.flightIndex === selectedIndex &&
                  item.fareIndex === fare.fareIndex
              )
          );

        // Build complete route
        const route = allSegments
          .map(
            (segment) =>
              segment.departAirportCode ||
              segment.departCityName ||
              ""
          )
          .filter(Boolean);

        const lastSegment =
          allSegments[allSegments.length - 1];

        if (lastSegment) {
          const destination =
            lastSegment.arrivalAirportCode ||
            lastSegment.arrivalCityName ||
            "";

          if (destination) {
            route.push(destination);
          }
        }

        return {
          optionIndex: optionIndex + 1,
          allSegments,
          route,
          fares,
        };
      })
      .filter(Boolean);
  };

  const getShareDateTime = (dateTime) => {
    if (!dateTime) return "N/A";

    const date = new Date(dateTime);

    if (Number.isNaN(date.getTime())) {
      return String(dateTime);
    }

    return date.toLocaleString("en-GB", {
      day: "2-digit",
      month: "short",
      year: "numeric",
      hour: "2-digit",
      minute: "2-digit",
      hour12: false,
    });
  };

  const getShareFareName = (fare, fareIndex = 0) => {
    return (
      fare?.journeyFareInfos?.[0]?.type ||
      fare?.fareName ||
      fare?.fareType ||
      `Fare ${fareIndex + 1}`
    );
  };

  const getShareAmountText = (fare) => {
    return Number(fare?.totalFare || 0).toLocaleString(
      "en-IN",
      { maximumFractionDigits: 2 }
    );
  };

  const getShareRefundStatus = (fare) => {
    const refundable =
      fare?.journeyFareInfos?.[0]?.isRefundable ??
      fare?.isRefundable;

    if (refundable === true) return "Refundable";
    if (refundable === false) return "Non Refundable";

    return "-";
  };


  const handleDownloadExcel = () => {
    if (!selectedShareFlights.length) {
      window.alert("Please select at least one flight.");
      return;
    }

    if (typeof XLSX === "undefined") {
      window.alert("Excel library is not available.");
      return;
    }

    const excelData = [];

    selectedShareFlights.forEach((selectedIndex, optionIndex) => {
      const flight = sortedFlights[selectedIndex];

      if (!flight) return;

      const segments = flight.segments || [];
      const firstSegment = segments[0] || {};
      const lastSegment = segments[segments.length - 1] || {};

      const duration = flight.totalDuration
        ? (() => {
          const [hours, minutes] = String(
            flight.totalDuration
          ).split(":");

          const h = parseInt(hours || 0, 10);
          const m = parseInt(minutes || 0, 10);

          return (
            `${h > 0 ? `${h}h ` : ""}` +
            `${m > 0 ? `${m}m` : ""}`
          ).trim() || "N/A";
        })()
        : firstSegment.duration || "N/A";

      const availableFares = (flight.fares || []).filter(
        (_, fareIndex) =>
          !removedShareFares.some(
            (item) =>
              item.flightIndex === selectedIndex &&
              item.fareIndex === fareIndex
          )
      );

      if (availableFares.length === 0) {
        excelData.push({
          Option: optionIndex + 1,
          Airline: firstSegment.airLineName || "Unknown Airline",
          FlightNumber: firstSegment.flightNumber || "",
          Departure: firstSegment.departDateTime
            ? formatTime(firstSegment.departDateTime)
            : "N/A",
          DepartureAirport:
            firstSegment.departAirportCode || "",
          Arrival: lastSegment.arrivalDateTime
            ? formatTime(lastSegment.arrivalDateTime)
            : "N/A",
          ArrivalAirport:
            lastSegment.arrivalAirportCode || "",
          Duration: duration,
          FareType: "No fares available",
          Amount: "",
          RefundStatus: "",
        });

        return;
      }

      availableFares.forEach((fare) => {
        const refundStatus =
          fare.journeyFareInfos?.[0]?.isRefundable ??
          fare.isRefundable;

        excelData.push({
          Option: optionIndex + 1,
          Airline: firstSegment.airLineName || "Unknown Airline",
          FlightNumber: [
            firstSegment.airLineCode,
            firstSegment.flightNumber,
          ]
            .filter(Boolean)
            .join(" "),
          Departure: firstSegment.departDateTime
            ? formatTime(firstSegment.departDateTime)
            : "N/A",
          DepartureAirport: [
            firstSegment.departCityName,
            firstSegment.departAirportCode
              ? `(${firstSegment.departAirportCode})`
              : "",
          ]
            .filter(Boolean)
            .join(" "),
          Arrival: lastSegment.arrivalDateTime
            ? formatTime(lastSegment.arrivalDateTime)
            : "N/A",
          ArrivalAirport: [
            lastSegment.arrivalCityName ||
            flight.arrivalCityName ||
            "",
            lastSegment.arrivalAirportCode
              ? `(${lastSegment.arrivalAirportCode})`
              : "",
          ]
            .filter(Boolean)
            .join(" "),
          Duration: duration,
          FareType:
            fare.journeyFareInfos?.[0]?.type ||
            fare.fareName ||
            fare.fareType ||
            "Fare",
          Amount: Number(fare.totalFare || 0),
          RefundStatus:
            refundStatus === true
              ? "Refundable"
              : refundStatus === false
                ? "Non Refundable"
                : "-",
        });
      });
    });

    if (excelData.length === 0) {
      window.alert("No valid flight data available to download.");
      return;
    }

    const worksheet = XLSX.utils.json_to_sheet(excelData);

    worksheet["!cols"] = [
      { wch: 10 },
      { wch: 24 },
      { wch: 16 },
      { wch: 20 },
      { wch: 24 },
      { wch: 20 },
      { wch: 24 },
      { wch: 12 },
      { wch: 24 },
      { wch: 16 },
      { wch: 18 },
    ];

    const workbook = XLSX.utils.book_new();

    XLSX.utils.book_append_sheet(
      workbook,
      worksheet,
      "Selected Flights"
    );

    XLSX.writeFile(workbook, "SelectedFlights.xlsx");
  };





  return (

    <div className="">
      <div className="row ruslt_sort mb-2 sticky">
        <div className="col-md-10 col-lg-10">
          <h3 className="destnation">
            {data.departureQuery?.split("(")[1]?.split(")")[0]}{" "}
            <i className="fa fa-arrow-right"></i>{" "}
            {data.arrivalQuery?.split("(")[1]?.split(")")[0]} || {" "}
            {[
              Number(data.adult) > 0 && `${data.adult} Adult`,
              Number(data.child) > 0 && `${data.child} Child`,
              Number(data.infant) > 0 && `${data.infant} Infant`
            ]
              .filter(Boolean)
              .join(", ")
            }

            <span style={{ color: "red" }}> || {formatDateForDisplay(data.onwardDate)}</span> || {requestBody.segments[0].preferredClass} ||

            {data?.fareType && (
              <span style={{ color: "#ff0000", marginLeft: "8px" }}>
                {data.fareType} ||
              </span>
            )}

            {flights.length > 0 && (
              <span style={{ color: "#ff0000", marginLeft: "10px" }}>flights : {flights.length}</span>
            )}

          </h3>
        </div>
        <div className="col-md-2 col-lg-2 text-center">
          <button
            className="modify_btn_sr"
            data-bs-toggle="modal"
            data-bs-target="#ModifyResult"
          >
            Modify Result <i className="fa fa-arrow-right"></i>
          </button>
        </div>
      </div>
      <div className="share_list mb-2">
        <div className="d-flex-reco">
          <div
            className={`fastest ${sortType === "CHEAPEST" ? "active" : ""}`}
            onClick={() => setSortType("CHEAPEST")}
            role="button"
            tabIndex={0}
          >
            <img src="/assets/images/rupee.png" alt="Cheapest" />
            <h4>Cheapest</h4>
          </div>

          <div
            className={`fastest ${sortType === "FASTEST" ? "active" : ""}`}
            onClick={() => setSortType("FASTEST")}
            role="button"
            tabIndex={0}
          >
            <img src="/assets/images/speed.png" alt="Fastest" />
            <h4>Fastest</h4>
          </div>

          <div
            className={`fastest ${sortType === "NONSTOP" ? "active" : ""}`}
            onClick={() => setSortType("NONSTOP")}
            role="button"
            tabIndex={0}
          >
            <img src="/assets/images/flight-blue.png" alt="Non Stop First" />
            <h4>Non Stop First</h4>
          </div>

          <div
            className={`fastest ${sortType === "DEPARTURE" ? "active" : ""}`}
            onClick={() => setSortType("DEPARTURE")}
            role="button"
            tabIndex={0}
          >
            <img src="/assets/images/flight-blue.png" alt="Departure" />
            <h4>Departure</h4>
          </div>

          <div
            className="ExportToExcl"
            onClick={() => ExportToExcel()}
            role="button"
            tabIndex={0}
          >
            <img src="/assets/images/excel.png" alt="Export To Excel" />
            <h4>Export To Excel</h4>
          </div>
          <div
            className="share_it"
            onClick={() => setshowAdSelct((prev) => !prev)}
            role="button"
            tabIndex={0}
          >
            <img src="/assets/images/share.png" alt="share flights" />
            <h4>Share IT</h4>
          </div>

          {showAdSelct && (
            <div className="shareit" data-bs-toggle="modal" data-bs-target="#shareFlights"> :
              <img src="/assets/images/copy.png" alt="share flights Details" />
            </div>
          )}
        </div>

      </div>



      {/* Loader */}


      {error && <p style={{ color: "red" }}>{error}</p>}
      {!loading && flights.length === 0 && !error && <p>No flights found.</p>}

      {/* Flights list */}
      {flights.length > 0 && (
        <>

          <div className="results">

            {sortedFlights.map((f, idx) => {
              const seg = f.segments?.[0] || {};

              const segments = f.segments || [];

              // Safety check
              const firstSeg = segments[0] || {};
              const lastSeg = segments[segments.length - 1] || {};

              // Flight Info
              const airLineCode =
                f.airLineCode || firstSeg.airLineCode || "";
              const airLineName =
                firstSeg.airLineName ||
                firstSeg.airlineName ||
                firstSeg.carrierName ||
                "Unknown Airline";
              const flightNumber =
                f.flightNumber || firstSeg.flightNumber || "";

              // Locations
              const origin =
                firstSeg.departAirportCode || f.departAirportCode || f.org || "";
              const destination =
                lastSeg.arrivalAirportCode || f.arrivalAirportCode || f.dest || "";

              // Timing (THIS IS THE MAIN FIX)
              const departTime =
                firstSeg.departDateTime || f.departDateTime || "";
              const arrivalTime =
                lastSeg.arrivalDateTime || f.arrivalDateTime || "";

              // Stops (correct for all cases)
              const stops =
                segments.length > 0 ? segments.length - 1 : 0;

              // Duration (correct end-to-end)
              //const totalDuration = f.totalDuration + " h";//||  calcDuration(departTime, arrivalTime);
              const [hours, minutes] = f.totalDuration.split(":");

              const h = parseInt(hours);
              const m = parseInt(minutes);

              const totalDuration =
                `${h > 0 ? h + "h " : ""}${m > 0 ? m + "m" : ""}`.trim();

              // Fare Info
              const totalFare =
                Number(f.fares?.[0]?.totalFare || f.fare?.totalFare || 0);
              const isRefundable =
                f.fares?.[0]?.isRefundable ?? false;

              const policyStatus =
                selectedFareMap[f?.itemNo]?.policyStatus ||
                f?.fares?.[0]?.policyStatus ||
                f?.policyStatus ||
                "";
              return (
                <div key={idx} className="result_repeat mb-2">
                  <div className="row">
                    {/* Left Section */}
                    <div className="col-md-8 col-lg-8">
                      <div className="row">
                        <div className="col-md-4 col-lg-4">
                          <div className="row">
                            <div className="col-md-4 col-lg-4">
                              <div className="flight_img">
                                <div>
                                  <img
                                    src={`/assets/images/Flight_Images/${f.segments[0].airLineCode}.gif`}
                                    alt={f.segments[0].airLineName}
                                    width="50"
                                  />
                                </div>

                              </div>
                            </div>
                            <div className="col-md-8 col-lg-8">
                              <figure className="flight_sect">
                                <span className="airlineImage">
                                  {f?.segments?.[0]?.airLineName}
                                </span>

                                {f?.segments?.map((seg, i) => (
                                  <span className="multi_flgt" key={i}>
                                    {seg.airLineCode}-{seg.flightNumber}
                                    {i < f.segments.length - 1 && " || "}
                                  </span>
                                ))}
                              </figure>
                            </div>
                          </div>
                        </div>

                        <div className="col-md-8 col-lg-8 border-left-right">
                          <div className="row">
                            <div className="col-md-4 col-lg-4 col-4">
                              <div className="timer">
                                <h4>{formatTime(departTime)}</h4>
                                <p>{origin}</p>
                              </div>
                            </div>
                            <div className="col-md-3 col-lg-3 col-3">
                              <div className="deruation">
                                <p>{totalDuration}</p>
                                <div className="bordr_top">
                                  <i className="fa fa-plane"></i>
                                </div>
                                <p className="stops">{stops} stop</p>
                              </div>
                            </div>
                            <div className="col-md-4 col-lg-4 offset-1 col-4">
                              <div className="timer">
                                <h4>{formatTime(arrivalTime)}</h4>
                                <p>{destination}</p>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    {/* Right Price Section */}
                    <div className="col-md-4 col-lg-4">
                      <div className="price_view">
                        <div className="row">
                          <div className="col-md-7 col-lg-7">
                            <div className="flight_charge oneWy">
                              <i className="fa fa-inr"></i>
                              {
                                selectedFareMap[f?.itemNo]?.totalFare?.toLocaleString("en-IN") ||
                                f?.fares?.[0]?.totalFare?.toLocaleString("en-IN") ||
                                0
                              }

                              <p className="type_frs">
                                {
                                  selectedFareMap[f?.itemNo]?.journeyFareInfos?.[0]?.type ||
                                  f?.fares?.[0]?.journeyFareInfos?.[0]?.type ||
                                  "Regular"
                                }
                              </p>

                            </div>
                            <button
                              className="view_more"
                              onClick={() => handleViewMoreFare(f)}
                            >
                              View More Fare
                            </button>
                          </div>
                          <div className="col-md-5 col-lg-5">
                            {showAdSelct && (
                              <div className="form-check w-100 d-flex justify-content-center">
                                <input
                                  className="form-check-input"
                                  type="checkbox"
                                  checked={selectedShareFlights.includes(idx)}
                                  onChange={(e) => {
                                    if (e.target.checked) {
                                      setSelectedShareFlights((prev) => [
                                        ...prev,
                                        idx,
                                      ]);
                                    } else {
                                      setSelectedShareFlights((prev) =>
                                        prev.filter((selectedIndex) => selectedIndex !== idx)
                                      );
                                    }
                                  }}
                                />
                              </div>
                            )}
                            <p
                              className={`policyStatus ${policyStatus === "WithinPolicy"
                                ? "text-success"
                                : policyStatus === "OutOfPolicy"
                                  ? "text-danger"
                                  : ""
                                }`}
                            >
                              {policyStatus && (
                                <img
                                  src={
                                    policyStatus === "WithinPolicy"
                                      ? "/assets/images/approved.png"
                                      : policyStatus === "OutOfPolicy"
                                        ? "/assets/images/cancelled.png"
                                        : ""
                                  }
                                  alt="status"
                                  style={{ marginRight: "6px" }}
                                />
                              )}

                              {policyStatus}
                            </p>

                            <button className="book_now_fly"
                              onClick={() => handleBookNow(f, 0)}
                              disabled={loadingFlightIndex === idx}
                            >
                              {loadingFlightIndex === idx ? "Checking Price..." : "Book Now"}
                            </button>
                            {/* <div className="In-Policy"> <img src="/assets/images/approved.png" /> In-Policy</div> */}
                            {/* <div className="Out-Policy"> <img src="/assets/images/cancelled.png" /> Out-Policy</div> */}
                          </div>
                        </div>
                      </div>
                    </div>
                    {f.segments.map((segment, index) => (
                      <div key={index}>

                      </div>
                    ))}
                    {/* Footer Info */}
                    <div className="col-md-12 col-lg-12">
                      <ul className="list_service">
                        <li>
                          <div className="d-flex">
                            <div className="equipmentType">
                              <i className="fa-solid fa-fan"></i>
                              <span>{f.segments[0].equipmentType}</span>
                            </div>

                            <div className="equipmentType">
                              <img
                                className="seats"
                                src="/assets/images/seat.png"
                                alt="seat"
                              />
                              <span>{f.segments[0].availableSeats} Seats</span>
                            </div>
                          </div>

                        </li>
                        <li className="refundable">


                          {isRefundable ? (
                            <span style={{ color: "green" }}><i className="fa fa-inr" style={{ color: "green" }}></i> Refundable</span>
                          ) : (
                            <span style={{ color: "red" }}><i className="fa fa-inr" style={{ color: "red" }}></i> Non-Refundable</span>
                          )}

                        </li>
                        {["TMC Operations", "TMC Manager"].some(role => roles?.includes(role)) && (
                          <li className="view_on">
                            <p class="policyStatus text-success">{f.supSource}</p>
                          </li>
                        )}

                        <li className="view_on">

                          <a
                            className="flight_details"
                            data-bs-toggle="offcanvas"
                            data-bs-target="#FlightDetails"
                            //onClick={() => setSelectedFlight(f)}
                            onClick={() => {
                              setSelectedFlight(f);
                              setSelectedFare(f.fares?.[0]);
                            }}
                          >
                            <i className="fa fa-plane"></i> Flight Details
                          </a>
                        </li>
                      </ul>
                      {/* <p className="required_visa">
                          Dear, Don't need visa:{" "}
                          <span>{"Visa on Arrival"}</span>
                        </p> */}
                    </div>
                  </div>




                </div>

              );
            })}
          </div>
        </>
      )}
      {loading && <p className="text-center load"><span className="loader"></span></p>}

      <div className="offcanvas offcanvas-end" id="ViewMoreFare" tabIndex="-1" aria-labelledby="ViewMoreFareLabel">
        <div className="offcanvas-header">
          <h1 className="offcanvas-title" id="ViewMoreFareLabel">
            More Fare Options Available
          </h1>
          <button
            type="button"
            className="btn-close"
            data-bs-dismiss="offcanvas"
            aria-label="Close"
          ></button>
        </div>

        <div className="offcanvas-body">
          {selectedFlight ? (
            <>
              <div className="vie_fare d-flex align-items-center gap-3">
                <div className="from_to">
                  <img
                    alt={selectedFlight.segments?.[0]?.airLineName || "airline"}
                    src={`/assets/images/Flight_Images/${selectedFlight.segments?.[0]?.airLineCode}.gif`}
                  />
                </div>
                <div className="flight_time">
                  <span>
                    <strong>
                      {selectedFlight.segments?.[0]?.departCityName} ({selectedFlight.segments?.[0]?.departAirportCode}) →{" "}
                      {selectedFlight.arrivalCityName ||
                        selectedFlight.segments?.[selectedFlight.segments.length - 1]?.arrivalCityName}
                      (
                      {selectedFlight.segments?.[selectedFlight.segments.length - 1]?.arrivalAirportCode}
                      )
                    </strong>
                  </span>
                  <span>
                    <strong>{selectedFlight.segments?.[0]?.airLineName}</strong>
                  </span>

                  <span>
                    <strong>
                      {new Date(
                        selectedFlight.segments?.[0]?.departDateTime
                      ).toDateString()}
                    </strong>
                  </span>
                  <span>
                    Departure at:{" "}
                    <strong>{formatTime(selectedFlight.segments?.[0]?.departDateTime)}</strong>
                  </span>
                  <span>
                    Arrival at:{" "}
                    <strong>{formatTime(selectedFlight.segments?.[0]?.arrivalDateTime)}</strong>
                  </span>
                </div>
              </div>

              <div className="d-flex flex-wrap mt-3">
                {selectedFlight.fares?.length > 0 ? (
                  selectedFlight.fares.map((fare, index) => (
                    <div key={index} className="Select_new_fare repeat_section">
                      <h5>{fare?.journeyFareInfos[0]?.type}</h5>
                      <p
                        className={`policyStatus text-en ${fare?.policyStatus === "WithinPolicy"
                          ? "text-success"
                          : fare?.policyStatus === "OutOfPolicy"
                            ? "text-danger"
                            : ""
                          }`}
                      >
                        {fare?.policyStatus && (
                          <img
                            src={
                              fare.policyStatus === "WithinPolicy"
                                ? "/assets/images/approved.png"
                                : fare.policyStatus === "OutOfPolicy"
                                  ? "/assets/images/cancelled.png"
                                  : ""
                            }
                            alt="status"
                            style={{ marginRight: "6px" }}
                          />
                        )}

                        {fare.policyStatus}
                      </p>
                      <h3>
                        <i className="fa fa-inr"></i>{" "}
                        {fare.totalFare?.toLocaleString("en-IN")}
                      </h3>

                      <div className="riepet d-flex flex-wrap justify-content-between">

                        <div className="baggage">
                          <h4>
                            <i className="fa fa-suitcase-rolling"></i> Fare Inclusions
                          </h4>

                          <ul>
                            {fare.fareInclusions && fare.fareInclusions.length > 0 ? (
                              fare.fareInclusions.map((item, i) => (
                                <li key={i}> {item}</li>
                              ))
                            ) : (
                              <li>No fare inclusions available</li>
                            )}
                          </ul>
                        </div>
                      </div>

                      <div className="d-flex-btn d-flex justify-content-between align-items-center mt-2">
                        <p
                          className="refun"
                          style={{
                            color: fare.isRefundable ? "green" : "red",
                            fontWeight: "500",
                          }}
                        >
                          {fare.isRefundable ? "Refundable" : "Non Refundable"}
                        </p>
                        <p
                          className="faReRule"
                          data-bs-toggle="modal"
                          data-bs-target="#FareRuleModal"
                          onClick={() => {
                            setLoadFareRule(true);
                            setFareRuleIndex(index);
                          }}
                        >
                          Fare Rule
                        </p>
                        <button
                          className="btn btn-primary btn-sm"
                          onClick={() => {
                            setSelectedFare(fare);
                            setSelectedFareIndex(index); // <-- IMPORTANT
                          }}
                        >
                          Select
                        </button>
                      </div>
                    </div>
                  ))
                ) : (
                  <p>No fare options available</p>
                )}
              </div>
            </>
          ) : (
            <p>No flight selected</p>
          )}
        </div>

        {selectedFare && (
          <div className="total_amount border-top p-3">
            <p className="Grand">Grand Total <span style={{ color: 'red' }}>({selectedFare?.journeyFareInfos[0]?.type || ""})</span> </p>
            <h1>
              <i className="fa fa-inr"></i>{" "}
              {selectedFare?.totalFare?.toLocaleString("en-IN")}
            </h1>
            <button
              className="btn btn-primary"
              onClick={() => {
                if (!selectedFare) {
                  alert("Please select a fare");
                  return;
                }

                const updatedFlight = {
                  ...selectedFlight,
                  selectedFare: selectedFare
                };

                handleBookNow(updatedFlight, selectedFareIndex);
              }}
              data-bs-dismiss="offcanvas"
            >
              {loadingFlightIndex === selectedFareIndex ? "Checking ..." : "Book Now"}
            </button>
          </div>
        )}
      </div>

      <div className="offcanvas offcanvas-end" tabIndex="-1" id="FlightDetails" aria-labelledby="FlightDetailsLabel">
        <div className="offcanvas-header">
          <h1 className="offcanvas-title">Flight Details</h1>

          <button
            type="button"
            className="btn-close"
            data-bs-dismiss="offcanvas"
            aria-label="Close"
            onClick={() => {
              setActiveTab("info");
              setLoadFareRuleTab(false);
            }}
          ></button>
        </div>

        <div className="offcanvas-body">
          {selectedFlight ? (
            <>
              <ul className="nav nav-tabs nav-line-tabs nav-line-tabs-2x mb-5 fs-6">


                <li className="nav-item">
                  <a
                    className={`nav-link ${activeTab === "info" ? "active" : ""}`}
                    data-bs-toggle="tab"
                    href="#kt_tab_pane_4"
                    onClick={() => setActiveTab("info")}
                  >
                    Flight Information
                  </a>
                </li>

                <li className="nav-item">
                  <a
                    className={`nav-link ${activeTab === "fare" ? "active" : ""}`}
                    data-bs-toggle="tab"
                    href="#kt_tab_pane_5"
                    onClick={() => {
                      setActiveTab("fare");
                      if (!selectedFlight?.itemNo) return;
                      setLoadFareRuleTab(true);
                    }}
                  >
                    Fare Rules & Cancellation Change Rule
                  </a>
                </li>

                <li className="nav-item">
                  <a
                    className={`nav-link ${activeTab === "baggage" ? "active" : ""}`}
                    data-bs-toggle="tab"
                    href="#kt_tab_pane_6"
                    onClick={() => setActiveTab("baggage")}
                  >
                    Baggage Information
                  </a>
                </li>



              </ul>

              <div className="tab-content" id="myTabContent">
                <div
                  className={`tab-pane fade ${activeTab === "info" ? "show active" : ""}`}
                  id="kt_tab_pane_4"
                >
                  {(() => {
                    const segments = selectedFlight?.segments || [];
                    const firstSeg = segments[0] || {};
                    const lastSeg = segments[segments.length - 1] || {};

                    const fmtDur = (d) => {
                      if (!d) return "N/A";
                      const [h, m] = String(d).split(":").map((n) => parseInt(n, 10) || 0);
                      return `${h > 0 ? `${h}h ` : ""}${m > 0 ? `${m}m` : ""}`.trim() || "N/A";
                    };

                    const diffDur = (from, to) => {
                      if (!from || !to) return "";
                      const diff = new Date(to) - new Date(from);
                      if (!(diff > 0)) return "";
                      const mins = Math.floor(diff / 60000);
                      return fmtDur(`${Math.floor(mins / 60)}:${mins % 60}`);
                    };

                    const fmtDate = (dt) =>
                      dt
                        ? new Date(dt).toLocaleDateString("en-GB", {
                          weekday: "short",
                          day: "2-digit",
                          month: "short",
                          year: "numeric",
                        })
                        : "N/A";

                    const fmtTime = (dt) => (dt ? formatTime(dt) : "N/A");

                    const sameDay = (a, b) =>
                      new Date(a).toDateString() === new Date(b).toDateString();

                    const stopCount = Math.max(segments.length - 1, 0);
                    const travellers =
                      (Number(selectedFlight?.adult) || 0) +
                      (Number(selectedFlight?.child) || 0) +
                      (Number(selectedFlight?.infant) || 0);
                    const cabin = requestBody?.segments?.[0]?.preferredClass;
                    const destCity =
                      lastSeg.arrivalCityName || selectedFlight?.arrivalCityName || lastSeg.arrivalAirportCode;

                    return (
                      <div className="fd-wrap">
                        {/* ===== HEADER ===== */}
                        <div className="fd-hero">
                          <div className="fd-hero-route">
                            <div className="fd-hero-city">
                              <span className="fd-code">{firstSeg.departAirportCode}</span>
                              <span className="fd-city">{firstSeg.departCityName}</span>
                            </div>

                            <div className="fd-hero-mid">
                              <span className="fd-hero-dur">{fmtDur(selectedFlight?.totalDuration)}</span>
                              <div className="fd-hero-line">
                                <i className="fa fa-plane"></i>
                              </div>
                              <span className="fd-hero-stops">
                                {stopCount === 0 ? "Non-stop" : `${stopCount} Stop${stopCount > 1 ? "s" : ""}`}
                              </span>
                            </div>

                            <div className="fd-hero-city text-end">
                              <span className="fd-code">{lastSeg.arrivalAirportCode}</span>
                              <span className="fd-city">{destCity}</span>
                            </div>
                          </div>

                          <div className="fd-chips">
                            <span className="fd-chip"><i className="fa fa-calendar"></i> {fmtDate(firstSeg.departDateTime)}</span>
                            {cabin && <span className="fd-chip"><i className="fa fa-couch"></i> {cabin}</span>}
                            <span className="fd-chip"><i className="fa fa-user"></i> {travellers} Traveller(s)</span>
                          </div>
                        </div>

                        {/* ===== SEGMENTS ===== */}
                        {segments.map((seg, index) => {
                          const nextSeg = segments[index + 1];
                          const layover =
                            (seg.connectionTime && fmtDur(seg.connectionTime)) ||
                            (nextSeg && diffDur(seg.arrivalDateTime, nextSeg.departDateTime));
                          const overnight = !sameDay(seg.departDateTime, seg.arrivalDateTime);

                          return (
                            <React.Fragment key={`${seg.flightNumber || "f"}-${index}`}>
                              <div className="fd-card">
                                {/* Airline row */}
                                <div className="fd-airline">
                                  <div className="fd-airline-left">
                                    <img
                                      className="fd-logo"
                                      src={`/assets/images/Flight_Images/${seg.airLineCode}.gif`}
                                      alt={seg.airLineName || "Airline"}
                                    />
                                    <div>
                                      <strong>{seg.airLineName || "Airline"}</strong>
                                      <small>
                                        {seg.airLineCode}-{seg.flightNumber}
                                        {seg.equipmentType ? ` • ${seg.equipmentType}` : ""}
                                      </small>
                                    </div>
                                  </div>
                                  {/* {stopCount > 0 && <span className="fd-badge">Flight {index + 1}</span>} */}
                                </div>

                                {/* Timeline */}
                                <div className="fd-timeline">
                                  {/* Departure */}
                                  <div className="fd-point">
                                    <div className="fd-time">
                                      <strong>{fmtTime(seg.departDateTime)}</strong>
                                      <small>{fmtDate(seg.departDateTime)}</small>
                                    </div>
                                    <span className="fd-dot"></span>
                                    <div className="fd-place">
                                      <h4>
                                        {seg.departCityName || seg.departAirportCode} ({seg.departAirportCode})
                                      </h4>
                                      <p>
                                        {seg.departAirportName}
                                        {seg.departTerminal && (
                                          <span className="fd-term">Terminal {seg.departTerminal}</span>
                                        )}
                                      </p>
                                    </div>
                                  </div>

                                  {/* Duration */}
                                  <div className="fd-travel">
                                    <i className="fa fa-clock"></i> {fmtDur(seg.duration)}
                                  </div>

                                  {/* Arrival */}
                                  <div className="fd-point">
                                    <div className="fd-time">
                                      <strong>{fmtTime(seg.arrivalDateTime)}</strong>
                                      <small>
                                        {fmtDate(seg.arrivalDateTime)}
                                        {overnight && <em className="fd-next">+1 day</em>}
                                      </small>
                                    </div>
                                    <span className="fd-dot fd-dot-end"></span>
                                    <div className="fd-place">
                                      <h4>
                                        {seg.arrivalCityName || seg.arrivalAirportCode} ({seg.arrivalAirportCode})
                                      </h4>
                                      <p>
                                        {seg.arrivalAirportName}
                                        {seg.arrivalTerminal && (
                                          <span className="fd-term">Terminal {seg.arrivalTerminal}</span>
                                        )}
                                      </p>
                                    </div>
                                  </div>
                                </div>
                              </div>

                              {/* Layover */}
                              {nextSeg && (
                                <div className="fd-layover">
                                  <i className="fa fa-hourglass-half"></i>
                                  <span>
                                    {/* Layover at{" "}
                    <strong>
                      {seg.arrivalCityName || seg.arrivalAirportName} ({seg.arrivalAirportCode})
                    </strong>
                    {" • "} */}
                                    <strong>{seg.layoverMessage || "N/A"}</strong>
                                    {/* {seg.changeOfPlane ? " • Change of plane" : ""} */}
                                  </span>
                                </div>
                              )}
                            </React.Fragment>
                          );
                        })}
                      </div>
                    );
                  })()}
                </div>

                <div className="tab-pane fade" id="kt_tab_pane_5" role="tabpanel">
                  <div className="row">
                    <div className="col-md-12">
                      <FareRule
                        load={loadFareRuleTab}
                        clientCode={requestBody?.clientCode}
                        keyValue={requestBody?.key}
                        supplierCode={requestBody?.supplierCode}
                        departAirportCode={requestBody?.origin}
                        arrivalAirportCode={requestBody?.destination}
                        resultIndex={selectedFlight?.itemNo}
                        sessionID={requestBody?.sessionID}
                        flight={selectedFlight}
                        index={0}
                      />
                    </div>
                  </div>
                </div>
                <div className="tab-pane fade" id="kt_tab_pane_6" role="tabpanel">
                  <table className="table table-bordered">
                    <tbody>
                      <tr>
                        <th>Airline</th>
                        <th>Fare Type</th>
                        <th>Check-in Baggage</th>
                        <th>Cabin Baggage</th>
                      </tr>
                      {/* {(selectedFlight.fares || []).map((fare, fareIndex) => ( */}
                        <tr>
                          <td>
                            <img
                              className="flight_name"
                              src={`/assets/images/Flight_Images/${selectedFlight.segments?.[0]?.airLineCode}.gif`}
                              alt={selectedFlight.segments?.[0]?.airLineName}
                            />
                            <p className="plane_name">
                              {selectedFlight.segments?.[0]?.airLineName}
                            </p>
                            <p className="code_plne">{selectedFlight.segments?.[0]?.airLineCode}-
                            {selectedFlight.segments?.[0]?.flightNumber}</p>
                          </td>

                          <td>{selectedFlight.fares?.[0]?.journeyFareInfos?.[0]?.type}</td>
                          <td>
                            {selectedFlight.fares?.[0]?.journeyFareInfos?.[0]?.baggageDetails?.[0]?.baggage}
                          </td>
                          <td>
                            {selectedFlight.fares?.[0]?.journeyFareInfos?.[0]?.baggageDetails?.[0]?.cabinBaggage}
                          </td>
                        </tr>
                       {/* ))} */}
                      
                      <tr>
                        <td colspan="4">
                          <div className="termsbagg">
                            <ul>
                              <li>Baggage information mentioned above is obtained from airline's reservation system, Berry Journeys does not guarantee the accuracy of this information.</li>
                              <li>The baggage allowance may vary according to stop-overs, connecting flights. changes in airline rules. etc.</li>
                            </ul>
                          </div>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>

              </div>

              <div className="total_amount">
                <p className="Grand">Grand Total</p>
                <h1>
                  <i className="fa fa-inr"></i>{" "}
                  {Number(selectedFlight.fares?.[0]?.totalFare || 0).toLocaleString()}
                </h1>
                <button
                  className="btn btn-primary"
                  onClick={() => {
                    if (!selectedFare) {
                      alert("Please select a fare");
                      return;
                    }

                    const updatedFlight = {
                      ...selectedFlight,
                      selectedFare: selectedFare
                    };

                    handleBookNow(updatedFlight, 0);
                  }}
                >
                  {loadingFlightIndex !== null && loadingFlightIndex === selectedFareIndex
                    ? "CheckingPrice..."
                    : "Book Now"}
                </button>

              </div>
            </>
          ) : (
            <p>No flight selected</p>
          )}
        </div>
      </div>


      <div className="modal fade" id="FareRuleModal" tabIndex="-1">
        <div className="modal-dialog modal-lg">
          <div className="modal-content">

            <div className="modal-header">
              <h4 className="modal-title">Fare Rule</h4>
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                onClick={() => setLoadFareRule(false)}
              ></button>
            </div>

            <div className="modal-body">
              <div className="row">
                {selectedFlight && loadFareRule && fareRuleIndex !== null && (
                  <>
                    <div className="col-md-12">
                      <FareRule
                        load={loadFareRule}
                        clientCode={requestBody?.clientCode}
                        keyValue={requestBody?.key}
                        supplierCode={requestBody?.supplierCode}
                        departAirportCode={requestBody?.origin}
                        arrivalAirportCode={requestBody?.destination}
                        resultIndex={selectedFlight?.itemNo}
                        sessionID={requestBody?.sessionID}
                        flight={selectedFlight}
                        index={fareRuleIndex}
                      />
                    </div>
                  </>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* select flight to share start */}


      <div className="modal fade" id="shareFlights" tabIndex="-1">
        <div className="modal-dialog modal-90 modal-dialog-scrollable">
          <div className="modal-content">

            {/* Modal Header */}
            <div className="modal-header">
              <h4 className="modal-title">
                Selected Flight to Share
              </h4>

              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              ></button>
            </div>

            {/* Modal Body */}
            <div className="modal-body">
              <div className="text_flght">
                <h6>Dear Sir/Ma'am,</h6>
                <p>
                  Please find the selected flight
                  options below.
                </p>
              </div>

              {selectedShareFlights.length === 0 ? (
                <div className="text-center py-4">
                  <p className="mb-0">
                    No flight selected. Please select at least one.
                  </p>
                </div>
              ) : (
                <>
                  {selectedShareFlights.map((selectedIndex, optionIndex) => {
                    const flight = sortedFlights[selectedIndex];

                    // Skip invalid flight indexes
                    if (!flight) {
                      return null;
                    }

                    const segments = flight.segments || [];
                    const firstSegment = segments[0] || {};
                    const lastSegment = segments[segments.length - 1] || {};

                    const stopCount = Math.max(segments.length - 1, 0);

                    const viaCities = segments
                      .slice(0, -1)
                      .map(
                        (segment) =>
                          segment.arrivalCityName ||
                          segment.arrivalCity ||
                          segment.arrivalAirportName ||
                          segment.destination ||
                          ""
                      )
                      .filter(Boolean);

                    const routeFrom =
                      firstSegment.departAirportCode ||
                      firstSegment.departCityName ||
                      "";

                    const routeTo =
                      lastSegment.arrivalAirportCode ||
                      lastSegment.arrivalCityName ||
                      flight.arrivalCityName ||
                      "";

                    const route =
                      routeFrom && routeTo
                        ? `${routeFrom} - ${routeTo}`
                        : routeFrom || routeTo || "N/A";

                    const removeFlight = () => {
                      setSelectedShareFlights((prev) =>
                        prev.filter((index) => index !== selectedIndex)
                      );

                      setRemovedShareFares((prev) =>
                        prev.filter(
                          (item) => item.flightIndex !== selectedIndex
                        )
                      );
                    };

                    return (
                      <div key={selectedIndex} className="mb-4">

                        {/* Option Heading */}
                        <div className="d-flex align-items-center justify-content-between mb-2">
                          <h6 className="optionIndex_list mb-0">
                            Option {optionIndex + 1}
                          </h6>

                          <button
                            type="button"
                            className="btn btn-remove"
                            onClick={removeFlight}
                            aria-label={`Remove option ${optionIndex + 1}`}
                            title="Remove flight option"
                          >
                            <img
                              src="/assets/images/delete.png"
                              alt="Remove option"
                              width={30}
                            />
                          </button>
                        </div>

                        {/* Flight Table */}
                        <div className="table-responsive">
                          <table className="table text-center align-middle table-bordered">
                            <thead
                              style={{
                                background: "#110942",
                                color: "#fff",
                              }}
                            >
                              <tr>
                                <th style={{ color: "#fff" }}>Action</th>
                                <th style={{ color: "#fff" }}>Flight</th>
                                <th style={{ color: "#fff" }}>Departure</th>
                                <th style={{ color: "#fff" }}>Arrived</th>
                                <th style={{ color: "#fff" }}>Duration</th>
                                <th style={{ color: "#fff" }}>Stops</th>
                                <th style={{ color: "#fff", minWidth: "150px" }}>
                                  Route
                                </th>
                                <th style={{ color: "#fff" }}>Fare</th>
                              </tr>
                            </thead>

                            <tbody>
                              <tr>
                                {/* Remove Flight */}
                                <td>
                                  <button
                                    type="button"
                                    className="btn p-0"
                                    title="Remove flight"
                                    onClick={removeFlight}
                                    aria-label="Remove flight"
                                  >
                                    <img
                                      src="/assets/images/delete.png"
                                      alt="Remove flight"
                                      width={20}
                                    />
                                  </button>
                                </td>

                                {/* Airline */}
                                <td>
                                  <div className="d-flex align-items-center justify-content-center gap-2">
                                    {firstSegment.airLineCode && (
                                      <img
                                        src={`/assets/images/Flight_Images/${firstSegment.airLineCode}.gif`}
                                        alt={firstSegment.airLineName || "Airline"}
                                        className="flight_i"
                                      />
                                    )}

                                    <span>
                                      {firstSegment.airLineName || "Unknown Airline"}{" "}
                                      {firstSegment.airLineCode || ""}-
                                      {firstSegment.flightNumber || ""}
                                    </span>
                                  </div>
                                </td>

                                {/* Departure */}
                                <td>
                                  <strong>
                                    {firstSegment.departDateTime
                                      ? formatTime(firstSegment.departDateTime)
                                      : "N/A"}
                                  </strong>

                                  <br />

                                  {firstSegment.departCityName || ""}

                                  {firstSegment.departAirportCode
                                    ? ` (${firstSegment.departAirportCode})`
                                    : ""}
                                </td>

                                {/* Arrival */}
                                <td>
                                  <strong>
                                    {lastSegment.arrivalDateTime
                                      ? formatTime(lastSegment.arrivalDateTime)
                                      : "N/A"}
                                  </strong>

                                  <br />

                                  {lastSegment.arrivalCityName ||
                                    flight.arrivalCityName ||
                                    ""}

                                  {lastSegment.arrivalAirportCode
                                    ? ` (${lastSegment.arrivalAirportCode})`
                                    : ""}
                                </td>

                                {/* Duration */}
                                <td>
                                  {flight.totalDuration
                                    ? (() => {
                                      const [hours, minutes] = String(
                                        flight.totalDuration
                                      ).split(":");

                                      const h = parseInt(hours || 0, 10);
                                      const m = parseInt(minutes || 0, 10);

                                      return (
                                        `${h > 0 ? `${h}h ` : ""}` +
                                        `${m > 0 ? `${m}m` : ""}`
                                      ).trim() || "N/A";
                                    })()
                                    : firstSegment.duration || "N/A"}
                                </td>

                                {/* Stops */}
                                <td>
                                  {stopCount === 0 ? (
                                    <strong>Non-stop</strong>
                                  ) : (
                                    <>
                                      <strong>
                                        {stopCount}{" "}
                                        {stopCount === 1 ? "Stop" : "Stops"}
                                      </strong>

                                      {viaCities.length > 0 && (
                                        <>
                                          <br />
                                          <span>
                                            via {viaCities.join(", ")}
                                          </span>
                                        </>
                                      )}
                                    </>
                                  )}
                                </td>

                                {/* Route */}
                                <td>{route}</td>

                                {/* Fare Table */}
                                <td>
                                  {flight.fares?.length > 0 ? (
                                    <table className="table table-bordered table-sm mb-0">
                                      <thead>
                                        <tr>
                                          <th>Fare Type</th>
                                          <th>Amount</th>
                                          <th>Price Type</th>
                                          <th></th>
                                        </tr>
                                      </thead>

                                      <tbody>
                                        {flight.fares.map((fare, fareIndex) => {
                                          const isRemoved = removedShareFares.some(
                                            (item) =>
                                              item.flightIndex === selectedIndex &&
                                              item.fareIndex === fareIndex
                                          );

                                          if (isRemoved) {
                                            return null;
                                          }

                                          const fareType =
                                            fare.journeyFareInfos?.[0]?.type ||
                                            fare.fareName ||
                                            fare.fareType ||
                                            `Fare ${fareIndex + 1}`;

                                          const priceType =
                                            fare.journeyFareInfos?.[0]
                                              ?.isRefundable ?? fare.isRefundable;

                                          return (
                                            <tr key={fareIndex}>
                                              {/* Fare Type */}
                                              <td>{fareType}</td>

                                              {/* Amount */}
                                              <td>
                                                <i className="fa fa-inr"></i>{" "}
                                                {Number(
                                                  fare.totalFare || 0
                                                ).toLocaleString("en-IN")}
                                              </td>

                                              {/* Refundability */}
                                              <td>
                                                <p
                                                  className="refun mb-0"
                                                  style={{
                                                    color:
                                                      priceType === true
                                                        ? "green"
                                                        : priceType === false
                                                          ? "red"
                                                          : "inherit",
                                                    fontWeight: "500",
                                                  }}
                                                >
                                                  {priceType === true
                                                    ? "Refundable"
                                                    : priceType === false
                                                      ? "Non Refundable"
                                                      : "-"}
                                                </p>
                                              </td>

                                              {/* Remove Fare */}
                                              <td className="text-center">
                                                <button
                                                  type="button"
                                                  className="btn p-0"
                                                  title="Remove price"
                                                  aria-label={`Remove ${fareType}`}
                                                  onClick={() => {
                                                    setRemovedShareFares((prev) => {
                                                      const alreadyRemoved =
                                                        prev.some(
                                                          (item) =>
                                                            item.flightIndex ===
                                                            selectedIndex &&
                                                            item.fareIndex ===
                                                            fareIndex
                                                        );

                                                      if (alreadyRemoved) {
                                                        return prev;
                                                      }

                                                      return [
                                                        ...prev,
                                                        {
                                                          flightIndex: selectedIndex,
                                                          fareIndex,
                                                        },
                                                      ];
                                                    });
                                                  }}
                                                >
                                                  <img
                                                    src="/assets/images/cancelled.png"
                                                    alt="Remove price"
                                                    width={20}
                                                  />
                                                </button>
                                              </td>
                                            </tr>
                                          );
                                        })}
                                      </tbody>
                                    </table>
                                  ) : (
                                    <span>Fare not available</span>
                                  )}
                                </td>
                              </tr>
                            </tbody>
                          </table>
                        </div>
                      </div>
                    );
                  })}
                </>
              )}
            </div>

            {/* Modal Footer */}
            <div className="modal-footer">
              <button
                type="button"
                className="btn btn-primary"
                disabled={selectedShareFlights.length === 0}
                onClick={handleWhatsAppSelectedFlights}
              >
                <img
                  src="/assets/images/whatsapp.png"
                  alt="Share flights on WhatsApp"
                  width={20}
                />{" "}
                WhatsApp
              </button>

              <button
                type="button"
                className="btn btn-primary"
                disabled={selectedShareFlights.length === 0}
                onClick={handleCopyHTML}
              >
                <img
                  src="/assets/images/copy-b.png"
                  alt="Copy HTML"
                  width={20}
                />{" "}
                Copy
              </button>

              <button
                type="button"
                className="btn btn-primary"
                disabled={selectedShareFlights.length === 0}
                onClick={handleDownloadExcel}
              >
                <img
                  src="/assets/images/download-w.png"
                  alt="Download Excel"
                  width={20}
                />{" "}
                Download
              </button>
            </div>

          </div>
        </div>
      </div>

      {/* select flight to share End */}

    </div>
  );
};

export default ResultHtml;
